<div class="list-wrapper">
  <!-- Mail list header -->
  <div class="header">
    <!-- Header left -->
    <div class="left">
      <!-- Category name -->
      <div class="category">{{ parcel.parcel?.addrLine1 }}</div>
    </div>

    <div class="pagination">
      <button mat-icon-button class="ml-auto" [routerLink]="['../']">
        <mat-icon [svgIcon]="'close'"></mat-icon>
      </button>
    </div>

    <!-- Loading bar -->
    <mat-progress-bar class="loading-progress-bar" *ngIf="isLoading" [mode]="'indeterminate'"></mat-progress-bar>
  </div>

  <!-- Mail list -->
  <div class="list" #parcelList>
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="Property">
        <div class="flex p-2">
          <div class="flex flex-col">
            <div class="flex flex-col items-center">
              @if (parcel.parcel?.addrLine1) {
                <img
                  src="https://maps.googleapis.com/maps/api/streetview?key={{ streetViewKey }}&size=600x200&location={{
                    parcel.parcel.addrLine1
                  }}"
                />
              }
            </div>
          </div>
        </div>
        <div class="flex items-center mt-auto pl-2 pr-2">
          <button class="mr-2 w-1/3" mat-stroked-button (click)="onSave(parcel)" [appAuthorize]="Permission.DEALS_ADD">
            <mat-icon [svgIcon]="'save'"></mat-icon>
            <span class="ml-3">Save</span>
          </button>
          <button mat-stroked-button class="ml-2 w-1/3" (click)="onGoogleMaps(parcel.parcel?.addrLine1)">
            <mat-icon [svgIcon]="'location_on'"></mat-icon>
            <span class="ml-3">Google</span>
          </button>
        </div>
        <div class="flex flex-col p-2">
          <table>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Lot</div>
                  <div>{{ parcel.taxAssessor?.areaLotAcres | number: '1.2-2' }} acres</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Land Use</div>
                  <div>{{ parcel.lot_size_acre | number: '1.2-2' }} acres</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Lot Area</div>
                  <div>{{ parcel.taxAssessor?.areaLotAcres | number: '1.0-0' }} acres</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Zoning</div>
                  <div>{{ parcel.taxAssessor?.zonedCodeLocal }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Asset Type</div>
                  <div>{{ parcel.taxAssessor?.zonedCodeLocal }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Apn</div>
                  <div>{{ parcel.parcel?.apn }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Year Built</div>
                  <div>{{ parcel.taxAssessor?.yearBuilt }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Units</div>
                  <div>{{ parcel.taxAssessor?.unitsCount }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Building SF</div>
                  <div>{{ parcel.taxAssessor?.areaBuilding | number: '1.0-0' }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Gross SF</div>
                  <div>{{ parcel.taxAssessor?.areaLotSf | number: '1.0-0' }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Tax Rate</div>
                  <div>{{ parcel.taxAssessor?.taxRateArea }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Tax Bill</div>
                  <div>
                    ${{ parcel.taxAssessor?.taxBilledAmount | number: '1.0-0' }} ({{
                      parcel.taxAssessor?.taxYearAssessed
                    }})
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Last Sale Date</div>
                  <div>{{ parcel.taxAssessor?.assessorLastSaleDate }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Last Sale Amount</div>
                  <div>${{ parcel.taxAssessor?.assessorLastSaleAmount | number: '1.0-0' }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Asset Type</div>
                  <div>
                    <ng-container
                      *ngIf="
                        parcel.taxAssessor?.propertyUseStandardized
                          | treoFindByKey: 'id' : (propertyUseCodes$ | async) as value
                      "
                    >
                      {{ value.name }}
                    </ng-container>
                  </div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">County</div>
                  <div>{{ parcel.taxAssessor?.situsCounty }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Assessed Land Value</div>
                  <div>${{ parcel.taxAssessor?.taxAssessedValueLand | number: '1.0-0' }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Assessed Total Value</div>
                  <div>${{ parcel.taxAssessor?.taxAssessedValueTotal | number: '1.0-0' }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Market Land Value</div>
                  <div>${{ parcel.taxAssessor?.taxMarketValueLand | number: '1.0-0' }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Market Total Value</div>
                  <div>${{ parcel.taxAssessor?.taxMarketValueTotal | number: '1.0-0' }}</div>
                </div>
              </td>
            </tr>
            <!-- this needs to be changed -->
          </table>
        </div>
      </mat-tab>

      <mat-tab label="History">
        <div class="flex p-2">
          <div class="flex flex-col">
            <div class="flex flex-col items-center">
              <img
                src="https://maps.googleapis.com/maps/api/streetview?key={{ streetViewKey }}&size=600x200&location={{
                  parcel.parcel?.addrLine1
                }}"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-col p-2">
          <p class="history-empty" *ngIf="!parcel.recorders?.length">No data found</p>
          <table>
            <ng-container *ngFor="let recorder of parcel.recorders">
              <tr>
                <td>
                  <div class="flex-auto">
                    <div class="font-semibold">Publication Date</div>
                    <div>{{ recorder.publicationDate }}</div>
                  </div>
                </td>
                <td>
                  <div class="flex-auto">
                    <div class="font-semibold">Amount</div>
                    <div>${{ recorder.transferAmount | number: '1.0-0' }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="flex-auto">
                    <div class="font-semibold">Title Company</div>
                    <div>{{ recorder.titleCompanyStandardizedName }}</div>
                  </div>
                </td>
                <td>
                  <div class="flex-auto">
                    <div class="font-semibold">Recorded Date</div>
                    <div>{{ recorder.recordingDate }}</div>
                  </div>
                </td>
              </tr>
              <tr *ngFor="let grantee of recorder.grantees">
                <td>
                  <div class="flex-auto">
                    <div class="font-semibold">Grantee Name</div>
                    <div>{{ grantee.name }}</div>
                  </div>
                </td>
              </tr>
              <tr *ngFor="let grantor of recorder.grantors">
                <td>
                  <div class="flex-auto">
                    <div class="font-semibold">Grantor Name</div>
                    <div>{{ grantor.name }}</div>
                  </div>
                </td>
              </tr>
              <tr *ngFor="let mortgage of recorder.mortgages">
                <td>
                  <div class="flex-auto">
                    <div class="font-semibold">Lender</div>
                    <div>{{ mortgage.name }}</div>
                  </div>
                </td>
                <td>
                  <div class="flex-auto">
                    <div class="font-semibold">Mortgage Amount</div>
                    <div>${{ mortgage.amount | number: '1.0-0' }}</div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </div>
      </mat-tab>

      <!-- I'm not sure about this data -->
      <mat-tab label="Ownership">
        <div class="flex p-2">
          <div class="flex flex-col">
            <div class="flex flex-col items-center">
              <img
                src="https://maps.googleapis.com/maps/api/streetview?key={{ streetViewKey }}&size=600x200&location={{
                  parcel.parcel?.addrLine1
                }}"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-col p-2">
          <table>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Owner Name</div>
                  <div>{{ parcel.taxAssessor?.deedOwner1NameFull }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Owner Type</div>
                  <div>Deed 1</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Owner Name</div>
                  <div>{{ parcel.taxAssessor?.deedOwner2NameFull }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Owner Type</div>
                  <div>Deed 2</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Owner Name</div>
                  <div>{{ parcel.taxAssessor?.deedOwner3NameFull }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Owner Type</div>
                  <div>Deed 3</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Owner Name</div>
                  <div>{{ parcel.taxAssessor?.deedOwner4NameFull }}</div>
                </div>
              </td>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Owner Type</div>
                  <div>Deed 4</div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="flex-auto">
                  <div class="font-semibold">Contact Owner Mailing Address</div>
                  <div>{{ parcel.taxAssessor?.contactOwnerMailAddressFull }}</div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
